import React, { useState } from 'react';
import { Logout, Settings, Info } from '@mui/icons-material';
import { Divider, ListItemIcon, Menu, MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { IStudentMenuOptions } from './types';
import { useDispatch } from 'react-redux';
import { logout } from '../../redux/slices/authSlice';
import useDataCleanup from '../../hooks/useDataCleanup';
import { StudentAccountSettings } from '../../Pages/Student/StudentAccountSettings';
import Modal from '../Modal/Modal';
import { routeIDs } from '../../Routes/RouteIds.routes';

export const StudentMenuOptions = ({
  setAnchorEl,
  anchorEl,
  open,
  setShowAbout,
}: IStudentMenuOptions) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClose = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(null);
  };
  const { removeData } = useDataCleanup();
  const [showAccountSetting, setShowAccountSetting] = useState(false);
  const handleLogout = () => {
    removeData();
    dispatch(logout());
    navigate(routeIDs.LOGIN);
  };

  return (
    <div>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem
          onClick={() => setShowAccountSetting(true)}
          sx={{ color: '#003366' }}
          id="student-account-settings"
        >
          <Settings
            fontSize="large"
            sx={{ marginLeft: '-4px', marginRight: '4px', color: '#003366' }}
          />
          Account Settings
        </MenuItem>
        <MenuItem onClick={() => setShowAbout(true)} sx={{ color: '#003366' }}>
          <ListItemIcon>
            <Info fontSize="large" sx={{ color: '#003366' }} />
          </ListItemIcon>
          About
        </MenuItem>
        <Divider />
        <MenuItem
          data-testid="student-logout-button"
          onClick={handleLogout}
          sx={{ color: '#003366' }}
        >
          <ListItemIcon>
            <Logout fontSize="large" sx={{ color: '#003366' }} />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
      <Modal
        isOpen={showAccountSetting}
        onClose={() => setShowAccountSetting(false)}
        showCloseButton={false}
      >
        <StudentAccountSettings setShowAccountSetting={setShowAccountSetting} />
      </Modal>
    </div>
  );
};
